import { useEffect, useState, useRef } from 'react'
import clsx from 'clsx'
import Logo from 'observian-ui/lib/logo'
import Button from 'observian-ui/lib/button'
import ContactModal from 'observian-ui/lib/modal/contact'
import { Link } from 'gatsby'
import { gsap, Elastic, Power1 } from 'gsap'
import MorphSVGPlugin from 'gsap/MorphSVGPlugin'
import _ from 'lodash'

import ContactForm from 'components/Form/Contact'

// import NavDropdown from '../Dropdown'
// import ServicesMenu from '../ServicesMenu'

import ProServiceMenu from './ProService'
import ManagedServiceMenu from './ManagedService'
import Collaboration from './Collaboration'
import style from './header.module.css'
import menu from './psmenu'

const Header = ({ isLandingPage }) => {
  const [isActive, setIsActive] = useState(false)
  const [mobileActive, setMobileActive] = useState(false)
  const [mobiletl] = useState(gsap.timeline({ paused: true }))
  const [pointerEvent, setPointerEvent] = useState('none')
  const [showModal, setShowModal] = useState(false)
  const [isSuccessful, setIsSuccessful] = useState(false)

  // const [displayServices, setDisplayServices] = useState(false)
  const pRef = useRef()
  const proServ = useRef()
  const managedServ = useRef()
  const collab = useRef()
  const [activeMenu, setActiveMenu] = useState(null)

  useEffect(() => {
    gsap.registerPlugin(MorphSVGPlugin)

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    if (null !== urlParams.get('utm_term')) {
      const dt = new Date()
      localStorage.setItem('keyword', urlParams.get('utm_term'))
      localStorage.setItem('date', `${dt.getFullYear()}/${dt.getMonth() + 1}/${dt.getDate()}`)
    }
    if (null !== urlParams.get('utm_medium')) {
      localStorage.setItem('utm_medium', urlParams.get('utm_medium'))
    }
    if (null !== urlParams.get('utm_source')) {
      localStorage.setItem('utm_source', urlParams.get('utm_source'))
    }
    if (null !== urlParams.get('utm_campaign')) {
      localStorage.setItem('utm_campaign', urlParams.get('utm_campaign'))
    }
    if (null !== urlParams.get('utm_content')) {
      localStorage.setItem('utm_content', urlParams.get('utm_content'))
    }
    if (null !== urlParams.get('utm_term')) {
      localStorage.setItem('utm_term', urlParams.get('utm_term'))
    }

    mobiletl
      .to(
        '.menumark',
        {
          duration: 0.25,
          morphSVG: '.xmark',
          ease: Power1.easeOut(),
        },
        'starttime'
      )
      .fromTo(
        `.${style.mobileNavContainer}`,
        { y: 500, opacity: 0 },
        { y: 0, opacity: 1, ease: Elastic.easeOut.config(1, 1), duration: 1 },
        'starttime'
      )
      .fromTo(
        `.${style.mobileNavItems}`,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 1, ease: Elastic.easeOut.config(1, 1) },
        'starttime'
      )
      .to('.menubutton', { scale: 1.1, duration: 1 })
  }, [])

  const mobileMenuClick = () => {
    if (mobileActive) {
      mobiletl.timeScale(3)
      mobiletl.reverse()
      setMobileActive(false)
      setPointerEvent('none')
    } else {
      mobiletl.timeScale(1)
      mobiletl.play()
      setMobileActive(true)
      setPointerEvent('auto')
    }
  }

  const mouseLeave = () => {
    resetMenu()
  }

  const resetMenu = () => {
    setActiveMenu(null)
    gsap.to(`.${style.menuwrap}`, { duration: 0.2, y: -25, opacity: 0, display: 'none' })
  }

  const mouseEnterClear = () => {
    resetMenu()
  }

  const getIcon = (desc) => {
    switch (desc) {
      case 'Cloud Migration':
        return (
          <img
            src="/images/clouds/nav/migration.png"
            alt="Cloud Migration"
            className={style.cloudIconNav}
          />
        )

      case 'Big Data & Analytics':
        return (
          <img src="/images/clouds/nav/bigdata.png" alt="Big Data" className={style.cloudIconNav} />
        )

      case 'Cost Optimization':
        return (
          <img
            src="/images/clouds/nav/costop.png"
            alt="Cost Optimization"
            className={style.cloudIconNav}
          />
        )

      case 'Application Modernization':
        return (
          <img
            src="/images/clouds/nav/devops.png"
            alt="DevOps Automation"
            className={style.cloudIconNav}
          />
        )

      case 'Security & Compliance':
        return (
          <img
            src="/images/clouds/nav/securitycomp.png"
            alt="Cloud Security"
            className={style.cloudIconNav}
          />
        )

      default:
        return ''
    }
  }

  const proServeEnter = () => {
    setActiveMenu('proservice')
    const xPos = proServ.current.getBoundingClientRect().x
    const currentDim = [880, 570]
    const duration = 0.25
    gsap.set(`.${style.menuwrap}`, { opacity: 1, display: 'block', y: 0 })
    gsap.to(`.${style.menuwrap}`, { left: xPos - currentDim[0] * 0.2, duration, skewX: 0 })
    gsap.to(`.${style.navbox}`, {
      width: currentDim[0],
      height: currentDim[1],
      duration,
    })
    gsap.to(`.${style.navlaser}`, { top: currentDim[1] * 0.9, duration })
    gsap.to(`.${style.toparrow}`, { left: currentDim[0] * 0.2, duration })
  }

  const managedServEnter = () => {
    setActiveMenu('managedservice')
    const xPos = managedServ.current.getBoundingClientRect().x
    const currentDim = [750, 580]
    const duration = 0.25
    gsap.set(`.${style.menuwrap}`, { opacity: 1, display: 'block', y: 0 })
    gsap.to(`.${style.menuwrap}`, { left: xPos - currentDim[0] * 0.2, duration })
    gsap.to(`.${style.navbox}`, { width: currentDim[0], height: currentDim[1], duration })
    gsap.to(`.${style.navlaser}`, { top: currentDim[1] * 0.92, duration })
    gsap.to(`.${style.toparrow}`, { left: currentDim[0] * 0.2, duration })
  }

  const collabEnter = () => {
    setActiveMenu('collaboration')
    const xPos = collab.current.getBoundingClientRect().x
    const currentDim = [800, 500]
    const duration = 0.45
    gsap.set(`.${style.menuwrap}`, { opacity: 1, display: 'block', y: 0 })
    gsap.to(`.${style.menuwrap}`, { left: xPos - currentDim[0] * 0.2, duration })
    gsap.to(`.${style.navbox}`, { width: currentDim[0], height: currentDim[1], duration })
    gsap.to(`.${style.navlaser}`, { top: currentDim[1] * 0.92, duration })
    gsap.to(`.${style.toparrow}`, { left: currentDim[0] * 0.2, duration })
  }

  return !isLandingPage ? (
    <header
      data-testid="nav-header"
      className={clsx(style.header, isActive && style.headerColor)}
      ref={pRef}
    >
      <div className={style.mobileNavButton} aria-label="Navigation Menu">
        <svg
          width="40px"
          height="24px"
          viewBox="0 0 40 24"
          onClick={mobileMenuClick}
          className="menubutton"
        >
          <path
            d="M0 16.187l33.38 1.948L40 21.083 2.083 22 0 16.187zm0-8.094l33.38 1.949L40 12.99l-37.917.917L0 8.093zM0 0l33.38 1.948L40 4.896l-37.917.917L0 0z"
            fill="#FFF"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
            className="menumark"
          />
          <path
            d="M0 0l10.669 6.169.052.013L18.842 3H23l-9.489 4.812 7.178 4.15L22 15 11.109 9.03 1.309 14 0 10.384l6.584-2.581-.295-1.416-5.007-2.745L0 0z"
            fill="#FFF"
            stroke="none"
            opacity="0"
            strokeWidth={1}
            fillRule="evenodd"
            className="xmark"
          />
        </svg>
      </div>
      <div className={style.mobileNavContainer} style={{ pointerEvents: pointerEvent }}>
        <div className={style.mobileNavItems}>
          <h3>
            Professional Services
            <svg className={style.headerunder} viewBox="0 0 118 29">
              <defs>
                <linearGradient
                  x1="12.4534884%"
                  y1="50.3409839%"
                  x2="87.8953488%"
                  y2="49.6712586%"
                  id="apslinemob"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-11.4%"
                  y="-115.5%"
                  width="122.8%"
                  height="331.1%"
                  filterUnits="objectBoundingBox"
                  id="bpslinemob"
                >
                  <feGaussianBlur stdDeviation={4} in="SourceGraphic" />
                </filter>
              </defs>
              <g
                transform="translate(8 4.944)"
                fill="url(#apslinemob)"
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
              >
                <path
                  opacity={0.509341969}
                  filter="url(#bpslinemob)"
                  d="M5.82645043e-13 5.05627441L3.89431763 15.4422913 105.110474 5.05627441z"
                />
                <path d="M0.440917969 0L4.3352356 10.3860168 105.551392 0z" />
              </g>
            </svg>
          </h3>
          <ul className={style.linksContainer}>
            <li className={style.liBump}>
              <Link to="/aws">Amazon Web Services</Link>
            </li>
            <li className={style.liBump}>
              <Link to="/google">Google Cloud</Link>
            </li>
            <li className={style.liBump}>
              <Link to="/azure">Microsoft Azure</Link>
            </li>
            {menu.map((item, key) => (
              <li className={style.links} key={`url:${item.href}`}>
                <div className={style.listItem}>
                  <Link to={item.href} className={style.psIcon}>
                    {getIcon(item.label)}
                  </Link>
                  <div>
                    <Link to={item.href} className={style.link} id={key}>
                      {item.label}
                    </Link>
                    <Link to={item.href} className={clsx(style.description, `navdesc${key}`)}>
                      {item.description}
                    </Link>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <h3>
            Managed Services
            <svg className={style.headerunder} viewBox="0 0 118 29">
              <defs>
                <linearGradient
                  x1="12.4534884%"
                  y1="50.3409839%"
                  x2="87.8953488%"
                  y2="49.6712586%"
                  id="apslinemob2"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-11.4%"
                  y="-115.5%"
                  width="122.8%"
                  height="331.1%"
                  filterUnits="objectBoundingBox"
                  id="bpslinemob2"
                >
                  <feGaussianBlur stdDeviation={4} in="SourceGraphic" />
                </filter>
              </defs>
              <g
                transform="translate(8 4.944)"
                fill="url(#apslinemob2)"
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
              >
                <path
                  opacity={0.509341969}
                  filter="url(#bpslinemob2)"
                  d="M5.82645043e-13 5.05627441L3.89431763 15.4422913 105.110474 5.05627441z"
                />
                <path d="M0.440917969 0L4.3352356 10.3860168 105.551392 0z" />
              </g>
            </svg>
          </h3>
          <ul className={style.linksContainer}>
            <li>
              <Link to="/managed-service">
                <svg viewBox="0 0 633 55" className={style.msSvg}>
                  <defs>
                    <linearGradient
                      x1="14.8581364%"
                      y1="50.7535005%"
                      x2="85.3734672%"
                      y2="49.2402223%"
                      id="acloudmob"
                    >
                      <stop stopColor="#1D8DBA" offset="0%" />
                      <stop stopColor="#03ECAE" offset="100%" />
                    </linearGradient>
                  </defs>
                  <g fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
                    <path
                      d="M257.175.75c-8.096 0-14.88 2.817-19.688 7.434-4.985 4.786-7.837 11.5-7.837 18.966 0 7.71 2.727 14.475 7.693 19.244 4.766 4.578 11.584 7.306 19.982 7.306 12.91 0 20.24-4.372 24.75-8.219V23.25h-21.45v11.175h5.925v3.171c-.812.618-3.124 1.779-7.2 1.779-3.44 0-6.255-1.246-8.223-3.382-1.973-2.14-3.102-5.193-3.102-8.843 0-3.45 1.192-6.36 3.158-8.425 2.013-2.114 4.845-3.35 8.092-3.35 4.11 0 7.063 1.43 9.615 3.537l9.596-10.345c-4.2-4.12-10.769-7.817-21.311-7.817zm-233.896.975H.75v51h17.025V21.936L24.29 48.75h15.62l6.515-26.814v30.789H63.45v-51H40.92L32.1 33.64 23.28 1.725zm79.912 0l17.631 51H102.94l-2.325-8.025H87.186l-2.325 8.025H67.878l17.631-51h17.682zm-9.282 16.74L89.913 32.85h7.892L93.91 18.465zm49.386-16.74H125.25v51h17.325V25.388l12.63 27.337h18.045v-51h-17.325v27.337l-12.63-27.337zm69.696 0l17.631 51H212.74l-2.325-8.025h-13.428l-2.325 8.025h-16.983l17.631-51h17.682zm-9.282 16.74l-3.996 14.385h7.892l-3.896-14.385zM318.6 1.725h-31.275v51H318.6V39.45h-13.8v-6.225h12.3V20.85h-12.3V15h13.8V1.725zm24 0c8.637 0 15.879 2.418 20.914 6.913 4.878 4.353 7.661 10.65 7.661 18.512 0 7.812-2.79 14.178-7.714 18.598-5.011 4.5-12.211 6.977-20.861 6.977h0-18v-51zm.825 13.5h-1.875v24h1.875c3.068 0 5.58-1.08 7.308-3.235 1.586-1.98 2.517-4.905 2.517-8.84 0-3.926-.927-6.81-2.505-8.753-1.727-2.126-4.243-3.172-7.32-3.172z"
                      stroke="url(#acloudmob)"
                      strokeWidth={1.5}
                      fillOpacity={0.55}
                      fill="url(#acloudmob)"
                      transform="translate(0 -267) translate(0 267)"
                    />
                    <path
                      d="M414.875 54.975c8.25 0 13.575-2.1 17.925-5.175l-5.625-15.075c-2.4 2.175-5.85 4.125-10.2 4.125-5.85 0-10.5-4.35-10.5-11.175 0-6.525 4.5-11.025 10.5-11.025 4.05 0 7.275 1.575 9.825 4.05l5.7-15c-4.2-2.925-9.675-5.175-17.625-5.175-17.1 0-28.275 12.075-28.275 27.15 0 16.35 11.85 27.3 28.275 27.3zm54.9-.975V39.225h-14.4V1.5h-19.05V54h33.45zm29.475.975c17.925 0 29.025-11.925 29.025-27.3 0-15.15-11.1-27.15-29.025-27.15-17.925 0-29.025 12-29.025 27.15 0 15.375 11.1 27.3 29.025 27.3zm0-15.675c-5.925 0-9.15-4.8-9.15-11.625 0-6.6 3.225-11.475 9.15-11.475 5.85 0 9.15 4.875 9.15 11.475 0 6.825-3.3 11.625-9.15 11.625zm56.025 15.675c15.75 0 24.3-8.925 24.3-21.6V1.5h-19.05v32.325c0 3.6-2.1 5.475-5.25 5.475-3.075 0-5.1-1.875-5.1-5.475V1.5h-19.05v31.875c0 12.675 8.475 21.6 24.15 21.6zm47.55-.975c17.625 0 29.325-10.125 29.325-26.325C632.15 11.25 620.3 1.5 602.825 1.5h-18.75V54h18.75zm.825-15h-1.125V16.5h1.125c5.475 0 9.075 3.525 9.075 11.175S609.125 39 603.65 39z"
                      fill="#00F6A5"
                      transform="translate(0 -267) translate(0 267)"
                    />
                  </g>
                </svg>
                <div className={style.msDesc}>
                  Cost Optimization, Account Monitoring, Architecture Reviews, Dedicated Support
                </div>
              </Link>
            </li>
            <li>
              <Link to="/managed-service">
                <svg viewBox="0 0 734 55" className={style.msSvg}>
                  <defs>
                    <linearGradient
                      x1="14.8581364%"
                      y1="50.7535005%"
                      x2="85.3734672%"
                      y2="49.2402223%"
                      id="asecmob"
                    >
                      <stop stopColor="#1D8DBA" offset="0%" />
                      <stop stopColor="#03ECAE" offset="100%" />
                    </linearGradient>
                  </defs>
                  <g fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
                    <path
                      d="M257.175.75c-8.096 0-14.88 2.817-19.688 7.434-4.985 4.786-7.837 11.5-7.837 18.966 0 7.71 2.727 14.475 7.693 19.244 4.766 4.578 11.584 7.306 19.982 7.306 12.91 0 20.24-4.372 24.75-8.219V23.25h-21.45v11.175h5.925v3.171c-.812.618-3.124 1.779-7.2 1.779-3.44 0-6.255-1.246-8.223-3.382-1.973-2.14-3.102-5.193-3.102-8.843 0-3.45 1.192-6.36 3.158-8.425 2.013-2.114 4.845-3.35 8.092-3.35 4.11 0 7.063 1.43 9.615 3.537l9.596-10.345c-4.2-4.12-10.769-7.817-21.311-7.817zm-233.896.975H.75v51h17.025V21.936L24.29 48.75h15.62l6.515-26.814v30.789H63.45v-51H40.92L32.1 33.64 23.28 1.725zm79.912 0l17.631 51H102.94l-2.325-8.025H87.186l-2.325 8.025H67.878l17.631-51h17.682zm-9.282 16.74L89.913 32.85h7.892L93.91 18.465zm49.386-16.74H125.25v51h17.325V25.388l12.63 27.337h18.045v-51h-17.325v27.337l-12.63-27.337zm69.696 0l17.631 51H212.74l-2.325-8.025h-13.428l-2.325 8.025h-16.983l17.631-51h17.682zm-9.282 16.74l-3.996 14.385h7.892l-3.896-14.385zM318.6 1.725h-31.275v51H318.6V39.45h-13.8v-6.225h12.3V20.85h-12.3V15h13.8V1.725zm24 0c8.637 0 15.879 2.418 20.914 6.913 4.878 4.353 7.661 10.65 7.661 18.512 0 7.812-2.79 14.178-7.714 18.598-5.011 4.5-12.211 6.977-20.861 6.977h0-18v-51zm.825 13.5h-1.875v24h1.875c3.068 0 5.58-1.08 7.308-3.235 1.586-1.98 2.517-4.905 2.517-8.84 0-3.926-.927-6.81-2.505-8.753-1.727-2.126-4.243-3.172-7.32-3.172z"
                      stroke="url(#asecmob)"
                      strokeWidth={1.5}
                      fillOpacity={0.55}
                      fill="url(#asecmob)"
                      transform="translate(0 -127) translate(0 127)"
                    />
                    <path
                      d="M407.6 54.975c12.525 0 20.475-6.6 20.475-16.95 0-14.775-20.55-15.975-20.55-20.925 0-.75.6-1.35 1.575-1.35 2.4 0 4.65 2.475 5.775 4.8l13.35-7.65c-1.425-4.5-8.1-12.375-20.1-12.375-11.775 0-19.725 6.6-19.725 16.725 0 15.525 20.475 16.2 20.475 21 0 .75-.525 1.275-1.5 1.275-2.325 0-5.025-2.25-6.975-5.55l-13.575 7.35c1.95 5.4 8.25 13.65 20.775 13.65zM464.3 54V39.225h-13.8V34.5h12.3V20.625h-12.3v-4.35h13.8V1.5h-32.775V54H464.3zm31.125.975c8.25 0 13.575-2.1 17.925-5.175l-5.625-15.075c-2.4 2.175-5.85 4.125-10.2 4.125-5.85 0-10.5-4.35-10.5-11.175 0-6.525 4.5-11.025 10.5-11.025 4.05 0 7.275 1.575 9.825 4.05l5.7-15c-4.2-2.925-9.675-5.175-17.625-5.175-17.1 0-28.275 12.075-28.275 27.15 0 16.35 11.85 27.3 28.275 27.3zm45.6 0c15.75 0 24.3-8.925 24.3-21.6V1.5h-19.05v32.325c0 3.6-2.1 5.475-5.25 5.475-3.075 0-5.1-1.875-5.1-5.475V1.5h-19.05v31.875c0 12.675 8.475 21.6 24.15 21.6zm47.25-.975V37.05L595.7 54h20.625l-12-21.975c4.425-2.475 8.325-7.425 8.325-13.5 0-9.525-7.2-17.025-19.5-17.025h-23.325V54h18.45zm2.25-30.9h-2.25v-7.35h2.25c2.4 0 3.75 1.875 3.75 3.675 0 1.8-1.35 3.675-3.75 3.675zm45.75 30.9V1.5h-19.05V54h19.05zm32.7 0V16.275h10.35V1.5H639.65v14.775h10.275V54h19.05zm48.6 0V31.575L734 1.5h-20.325l-5.25 14.925-5.25-14.925H682.1l16.425 30.075V54h19.05z"
                      fill="#00F0A9"
                      transform="translate(0 -127) translate(0 127)"
                    />
                  </g>
                </svg>
                <div className={style.msDesc}>
                  Cost Optimization, Account Monitoring, Architecture Reviews, Dedicated Support
                </div>
              </Link>
            </li>
            <li>
              <Link to="/aws/managed-security">
                <svg
                  style={{ minHeight: '50px', position: 'relative', top: '-8px' }}
                  viewBox="0 0 915 109"
                  className={style.msSvgaws}
                >
                  <defs>
                    <linearGradient
                      x1="14.8581364%"
                      y1="50.7535005%"
                      x2="85.3734672%"
                      y2="49.2402223%"
                      id="aawssec"
                    >
                      <stop stopColor="#1D8DBA" offset="0%" />
                      <stop stopColor="#03ECAE" offset="100%" />
                    </linearGradient>
                  </defs>
                  <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                    <path
                      d="M258.011 54.75c-8.095 0-14.88 2.817-19.688 7.434-4.984 4.786-7.837 11.5-7.837 18.966 0 7.71 2.727 14.475 7.693 19.244 4.767 4.578 11.584 7.306 19.982 7.306 12.91 0 20.24-4.372 24.75-8.219V77.25h-21.45v11.175h5.925v3.171c-.812.618-3.124 1.779-7.2 1.779-3.44 0-6.255-1.246-8.223-3.382-1.972-2.14-3.102-5.193-3.102-8.843 0-3.45 1.192-6.36 3.158-8.425 2.013-2.114 4.846-3.35 8.092-3.35 4.111 0 7.063 1.43 9.615 3.537l9.596-10.345c-4.199-4.12-10.769-7.817-21.31-7.817zm-233.896.975H1.586v51h17.025V75.936l6.515 26.814h15.62l6.515-26.814v30.789h17.025v-51H41.757l-8.82 31.915-8.822-31.915zm79.912 0l17.631 51h-17.883L101.45 98.7H88.023l-2.325 8.025H68.714l17.632-51h17.681zm-9.282 16.74L90.75 86.85h7.891l-3.896-14.385zm49.387-16.74h-18.046v51h17.325V79.388l12.63 27.337h18.045v-51h-17.325v27.337l-12.63-27.337zm69.695 0l17.631 51h-17.883L211.25 98.7h-13.427l-2.325 8.025h-16.984l17.632-51h17.681zm-9.282 16.74L200.55 86.85h7.891l-3.896-14.385zm114.891-16.74h-31.275v51h31.275V93.45h-13.8v-6.225h12.3V74.85h-12.3V69h13.8V55.725zm24 0c8.637 0 15.879 2.418 20.915 6.913 4.877 4.353 7.66 10.65 7.66 18.512 0 7.812-2.789 14.178-7.713 18.598-5.012 4.5-12.212 6.977-20.862 6.977h0-18v-51zm.825 13.5h-1.875v24h1.875c3.068 0 5.58-1.08 7.308-3.235 1.587-1.98 2.517-4.905 2.517-8.84 0-3.926-.927-6.81-2.504-8.753-1.727-2.126-4.244-3.172-7.32-3.172z"
                      stroke="url(#aawssec)"
                      strokeWidth={1.5}
                      fillOpacity={0.55}
                      fill="url(#aawssec)"
                      fillRule="nonzero"
                      transform="translate(-.836)"
                    />
                    <path
                      d="M405.811 108l2.325-8.025h12.3l2.325 8.025h19.5l-18.15-52.5h-18.75l-18.15 52.5h18.6zm11.4-21.375h-5.925l3-10.8 2.925 10.8zM465.436 108l6.375-27.525L478.186 108h19.125l13.65-52.5h-20.325l-4.875 28.875-6.45-28.875h-15l-6.45 28.875-4.875-28.875h-20.325l13.65 52.5h19.125zm65.4.975c12.525 0 20.475-6.6 20.475-16.95 0-14.775-20.55-15.975-20.55-20.925 0-.75.6-1.35 1.575-1.35 2.4 0 4.65 2.475 5.775 4.8l13.35-7.65c-1.425-4.5-8.1-12.375-20.1-12.375-11.775 0-19.725 6.6-19.725 16.725 0 15.525 20.475 16.2 20.475 21 0 .75-.525 1.275-1.5 1.275-2.325 0-5.025-2.25-6.975-5.55l-13.575 7.35c1.95 5.4 8.25 13.65 20.775 13.65zm57.75 0c12.525 0 20.475-6.6 20.475-16.95 0-14.775-20.55-15.975-20.55-20.925 0-.75.6-1.35 1.575-1.35 2.4 0 4.65 2.475 5.775 4.8l13.35-7.65c-1.425-4.5-8.1-12.375-20.1-12.375-11.775 0-19.725 6.6-19.725 16.725 0 15.525 20.475 16.2 20.475 21 0 .75-.525 1.275-1.5 1.275-2.325 0-5.025-2.25-6.975-5.55l-13.575 7.35c1.95 5.4 8.25 13.65 20.775 13.65zm56.7-.975V93.225h-13.8V88.5h12.3V74.625h-12.3v-4.35h13.8V55.5h-32.775V108h32.775zm31.125.975c8.25 0 13.575-2.1 17.925-5.175l-5.625-15.075c-2.4 2.175-5.85 4.125-10.2 4.125-5.85 0-10.5-4.35-10.5-11.175 0-6.525 4.5-11.025 10.5-11.025 4.05 0 7.275 1.575 9.825 4.05l5.7-15c-4.2-2.925-9.675-5.175-17.625-5.175-17.1 0-28.275 12.075-28.275 27.15 0 16.35 11.85 27.3 28.275 27.3zm45.6 0c15.75 0 24.3-8.925 24.3-21.6V55.5h-19.05v32.325c0 3.6-2.1 5.475-5.25 5.475-3.075 0-5.1-1.875-5.1-5.475V55.5h-19.05v31.875c0 12.675 8.475 21.6 24.15 21.6zm47.25-.975V91.05l7.425 16.95h20.625l-12-21.975c4.425-2.475 8.325-7.425 8.325-13.5 0-9.525-7.2-17.025-19.5-17.025h-23.325V108h18.45zm2.25-30.9h-2.25v-7.35h2.25c2.4 0 3.75 1.875 3.75 3.675 0 1.8-1.35 3.675-3.75 3.675zm45.75 30.9V55.5h-19.05V108h19.05zm32.7 0V70.275h10.35V55.5h-39.675v14.775h10.275V108h19.05zm48.6 0V85.575L914.986 55.5h-20.325l-5.25 14.925-5.25-14.925h-21.075l16.425 30.075V108h19.05z"
                      fill="#00F6A5"
                      fillRule="nonzero"
                      transform="translate(-.836)"
                    />
                    <path
                      d="M94.686 22.39c3.24 0 5.55-1.38 6.6-2.19l-.99-2.91c-.84.63-2.79 1.98-5.52 1.98-4.5 0-7.44-3.42-7.44-7.77s3.03-7.77 7.41-7.77c2.46 0 4.38 1.17 5.28 1.86l.99-2.94c-1.23-.93-3.39-2.04-6.36-2.04-6.15 0-10.77 4.71-10.77 10.89 0 6.18 4.44 10.89 10.8 10.89zm20.43-.39v-3h-7.35v-6.18h6.12V9.85h-6.12V4h7.05V1h-10.38v21h10.68zm6.99 0v-8.67h2.91l4.41 8.67h3.69l-5.1-9.42c2.13-.87 3.42-2.97 3.42-5.4 0-3.51-2.52-6.18-7.02-6.18h-5.64v21h3.33zm2.25-11.52h-2.25V3.91h2.25c2.43 0 3.63 1.32 3.63 3.27 0 2.13-1.53 3.3-3.63 3.3zM142.176 22V4h5.28V1h-13.89v3h5.28v18h3.33zm11.64 0V1h-3.33v21h3.33zm7.74 0v-8.94h6.15v-2.97h-6.15V4h7.02V1h-10.35v21h3.33zm14.07 0V1h-3.33v21h3.33zm15.09 0v-3h-7.35v-6.18h6.12V9.85h-6.12V4h7.05V1h-10.38v21h10.68zm8.61 0c6.93 0 11.19-3.66 11.19-10.5 0-6.57-4.17-10.5-11.19-10.5h-4.95v21h4.95zm.33-2.91h-1.95V3.94h1.95c4.5 0 7.41 2.73 7.41 7.56 0 5.01-2.91 7.59-7.41 7.59zM21.662 15.978c0 .905.099 1.639.271 2.177.198.539.444 1.126.79 1.762.123.196.172.392.172.563 0 .244-.148.49-.468.734l-1.554 1.027c-.222.147-.443.22-.64.22-.247 0-.494-.122-.74-.342a7.576 7.576 0 01-.888-1.15c-.247-.416-.493-.88-.764-1.443-1.923 2.25-4.34 3.376-7.25 3.376-2.07 0-3.722-.587-4.93-1.762-1.208-1.174-1.825-2.74-1.825-4.697 0-2.08.74-3.769 2.244-5.04 1.504-1.273 3.501-1.91 6.04-1.91.839 0 1.702.074 2.614.196.912.123 1.85.318 2.835.539V8.44c0-1.86-.394-3.156-1.158-3.914-.79-.759-2.12-1.126-4.02-1.126a11.3 11.3 0 00-2.662.318c-.912.22-1.8.49-2.663.832a7.11 7.11 0 01-.863.318 1.523 1.523 0 01-.394.074c-.345 0-.518-.245-.518-.759V2.985c0-.391.05-.685.173-.856.123-.172.345-.343.69-.514.863-.44 1.898-.808 3.107-1.101 1.208-.318 2.49-.465 3.846-.465 2.934 0 5.079.66 6.46 1.982 1.356 1.321 2.046 3.328 2.046 6.019v7.928h.05zm-10.01 3.719c.814 0 1.652-.147 2.54-.44.887-.294 1.676-.833 2.342-1.567.394-.464.69-.978.838-1.566a8.72 8.72 0 00.247-2.128v-1.028a20.732 20.732 0 00-2.269-.416 18.719 18.719 0 00-2.317-.147c-1.652 0-2.86.318-3.674.979-.813.66-1.208 1.59-1.208 2.814 0 1.15.296 2.006.912 2.593.592.612 1.455.906 2.59.906zm19.799 2.642c-.444 0-.74-.073-.937-.244-.198-.147-.37-.49-.518-.955L24.202 2.227c-.148-.49-.222-.808-.222-.98 0-.39.197-.61.592-.61h2.416c.468 0 .789.073.961.244.198.147.346.49.494.954l4.142 16.198L36.43 1.835c.123-.49.271-.807.468-.954.198-.147.543-.245.987-.245h1.972c.469 0 .79.074.986.245.198.147.37.49.469.954l3.895 16.394 4.266-16.394c.148-.49.32-.807.493-.954.197-.147.518-.245.961-.245h2.293c.395 0 .617.196.617.612 0 .122-.025.245-.05.391a3.46 3.46 0 01-.172.612l-5.942 18.914c-.148.49-.32.807-.518.954-.197.147-.518.245-.937.245H44.1c-.469 0-.79-.074-.986-.245-.198-.171-.37-.49-.469-.979L38.823 5.36l-3.797 15.757c-.124.49-.272.807-.469.979-.197.171-.542.244-.986.244h-2.12zM63.133 23c-1.282 0-2.564-.147-3.797-.44-1.233-.294-2.194-.612-2.835-.98-.395-.22-.666-.464-.765-.684a1.716 1.716 0 01-.148-.685v-1.248c0-.514.198-.759.567-.759.148 0 .296.025.444.074.148.049.37.146.617.244.838.367 1.75.661 2.712.857.986.195 1.947.293 2.934.293 1.553 0 2.761-.269 3.6-.807.838-.538 1.282-1.321 1.282-2.325 0-.685-.222-1.247-.666-1.712-.444-.465-1.282-.881-2.49-1.273l-3.575-1.1c-1.8-.564-3.132-1.395-3.945-2.496-.814-1.077-1.233-2.276-1.233-3.548 0-1.028.222-1.933.666-2.716a6.306 6.306 0 011.775-2.007c.74-.562 1.578-.978 2.564-1.272C61.826.122 62.862 0 63.947 0c.542 0 1.109.024 1.651.098a27.25 27.25 0 011.603.269c.493.122.962.245 1.405.392.444.146.79.293 1.036.44.345.196.592.391.74.612.148.195.222.465.222.807v1.15c0 .514-.198.783-.568.783-.197 0-.517-.098-.936-.294-1.406-.636-2.984-.954-4.734-.954-1.406 0-2.515.22-3.28.685-.764.465-1.158 1.175-1.158 2.178 0 .685.246 1.272.74 1.737.492.465 1.405.93 2.711 1.346l3.502 1.101c1.775.563 3.057 1.346 3.821 2.349.764 1.003 1.134 2.153 1.134 3.425 0 1.053-.222 2.007-.64 2.839a6.592 6.592 0 01-1.8 2.153c-.765.612-1.677 1.052-2.737 1.37-1.11.343-2.269.514-3.526.514z"
                      fill="#FFF"
                      fillRule="nonzero"
                      transform="translate(-.836)"
                    />
                    <path
                      d="M67.608 34.675c-8.062 6.075-19.774 9.3-29.845 9.3-14.114 0-26.831-5.325-36.437-14.175-.76-.7-.073-1.65.834-1.1 10.389 6.15 23.204 9.875 36.46 9.875 8.944 0 18.77-1.9 27.812-5.8 1.347-.625 2.499.9 1.176 1.9z"
                      fill="#F90"
                      transform="translate(-.836)"
                    />
                    <path
                      d="M70.965 30.775c-1.03-1.35-6.812-.65-9.434-.325-.784.1-.907-.6-.196-1.125 4.607-3.3 12.178-2.35 13.06-1.25.882 1.125-.245 8.85-4.557 12.55-.662.575-1.299.275-1.005-.475.98-2.475 3.16-8.05 2.132-9.375z"
                      fill="#F90"
                      transform="translate(-.836)"
                    />
                  </g>
                </svg>
                <div className={style.msDescaws}>
                  The 24/7 security alarm for your AWS environment.
                </div>
              </Link>
            </li>
            <li>
              <Link to="/managed-productivity">
                <svg viewBox="0 0 931 55" className={style.msSvgcollab}>
                  <defs>
                    <linearGradient
                      x1="14.8581364%"
                      y1="50.7535005%"
                      x2="85.3734672%"
                      y2="49.2402223%"
                      id="aprodmob"
                    >
                      <stop stopColor="#1D8DBA" offset="0%" />
                      <stop stopColor="#03ECAE" offset="100%" />
                    </linearGradient>
                  </defs>
                  <g fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
                    <path
                      d="M407.55 53.475v-16.5h3.975c11.475 0 19.125-7.575 19.125-18.15 0-10.35-7.2-17.85-19.35-17.85h-22.05v52.5h18.3zm1.725-30.3h-1.725v-7.95h1.875c2.25 0 3.825 1.65 3.825 3.975 0 2.55-1.875 3.975-3.975 3.975zm42.6 30.3v-16.95l7.425 16.95h20.625l-12-21.975c4.425-2.475 8.325-7.425 8.325-13.5 0-9.525-7.2-17.025-19.5-17.025h-23.325v52.5h18.45zm2.25-30.9h-2.25v-7.35h2.25c2.4 0 3.75 1.875 3.75 3.675 0 1.8-1.35 3.675-3.75 3.675zM506.7 54.45c17.925 0 29.025-11.925 29.025-27.3C535.725 12 524.625 0 506.7 0c-17.925 0-29.025 12-29.025 27.15 0 15.375 11.1 27.3 29.025 27.3zm0-15.675c-5.925 0-9.15-4.8-9.15-11.625 0-6.6 3.225-11.475 9.15-11.475 5.85 0 9.15 4.875 9.15 11.475 0 6.825-3.3 11.625-9.15 11.625zm50.625 14.7c17.625 0 29.325-10.125 29.325-26.325 0-16.425-11.85-26.175-29.325-26.175h-18.75v52.5h18.75zm.825-15h-1.125v-22.5h1.125c5.475 0 9.075 3.525 9.075 11.175s-3.6 11.325-9.075 11.325zm55.5 15.975c15.75 0 24.3-8.925 24.3-21.6V.975H618.9V33.3c0 3.6-2.1 5.475-5.25 5.475-3.075 0-5.1-1.875-5.1-5.475V.975H589.5V32.85c0 12.675 8.475 21.6 24.15 21.6zm55.425 0c8.25 0 13.575-2.1 17.925-5.175L681.375 34.2c-2.4 2.175-5.85 4.125-10.2 4.125-5.85 0-10.5-4.35-10.5-11.175 0-6.525 4.5-11.025 10.5-11.025 4.05 0 7.275 1.575 9.825 4.05l5.7-15C682.5 2.25 677.025 0 669.075 0c-17.1 0-28.275 12.075-28.275 27.15 0 16.35 11.85 27.3 28.275 27.3zm49.65-.975V15.75h10.35V.975H689.4V15.75h10.275v37.725h19.05zm32.7 0V.975h-19.05v52.5h19.05zm41.025 0L811.5.975h-20.025l-8.325 30.75-8.325-30.75H754.2l19.05 52.5h19.2zm40.875 0V.975h-19.05v52.5h19.05zm32.7 0V15.75h10.35V.975H836.7V15.75h10.275v37.725h19.05zm48.6 0V31.05L931.05.975h-20.325l-5.25 14.925-5.25-14.925H879.15l16.425 30.075v22.425h19.05z"
                      fill="#04E6AE"
                    />
                    <path
                      d="M257.175.75c-8.096 0-14.88 2.817-19.688 7.434-4.985 4.786-7.837 11.5-7.837 18.966 0 7.71 2.727 14.475 7.693 19.244 4.766 4.578 11.584 7.306 19.982 7.306 12.91 0 20.24-4.372 24.75-8.219V23.25h-21.45v11.175h5.925v3.171c-.812.618-3.124 1.779-7.2 1.779-3.44 0-6.255-1.246-8.223-3.382-1.973-2.14-3.102-5.193-3.102-8.843 0-3.45 1.192-6.36 3.158-8.425 2.013-2.114 4.845-3.35 8.092-3.35 4.11 0 7.063 1.43 9.615 3.537l9.596-10.345c-4.2-4.12-10.769-7.817-21.311-7.817zm-233.896.975H.75v51h17.025V21.936L24.29 48.75h15.62l6.515-26.814v30.789H63.45v-51H40.92L32.1 33.64 23.28 1.725zm79.912 0l17.631 51H102.94l-2.325-8.025H87.186l-2.325 8.025H67.878l17.631-51h17.682zm-9.282 16.74L89.913 32.85h7.892L93.91 18.465zm49.386-16.74H125.25v51h17.325V25.388l12.63 27.337h18.045v-51h-17.325v27.337l-12.63-27.337zm69.696 0l17.631 51H212.74l-2.325-8.025h-13.428l-2.325 8.025h-16.983l17.631-51h17.682zm-9.282 16.74l-3.996 14.385h7.892l-3.896-14.385zM318.6 1.725h-31.275v51H318.6V39.45h-13.8v-6.225h12.3V20.85h-12.3V15h13.8V1.725zm24 0c8.637 0 15.879 2.418 20.914 6.913 4.878 4.353 7.661 10.65 7.661 18.512 0 7.812-2.79 14.178-7.714 18.598-5.011 4.5-12.211 6.977-20.861 6.977h0-18v-51zm.825 13.5h-1.875v24h1.875c3.068 0 5.58-1.08 7.308-3.235 1.586-1.98 2.517-4.905 2.517-8.84 0-3.926-.927-6.81-2.505-8.753-1.727-2.126-4.243-3.172-7.32-3.172z"
                      stroke="url(#aprodmob)"
                      strokeWidth={1.5}
                      fillOpacity={0.55}
                      fill="url(#aprodmob)"
                    />
                  </g>
                </svg>
                <div className={style.msDesc}>
                  Data retention &amp; security for SAAS applications.
                </div>
              </Link>
            </li>
          </ul>

          <h3>
            Collaboration Solutions
            <svg className={style.headerunder} viewBox="0 0 118 29">
              <defs>
                <linearGradient
                  x1="12.4534884%"
                  y1="50.3409839%"
                  x2="87.8953488%"
                  y2="49.6712586%"
                  id="apslinemob3"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-11.4%"
                  y="-115.5%"
                  width="122.8%"
                  height="331.1%"
                  filterUnits="objectBoundingBox"
                  id="bpslinemob3"
                >
                  <feGaussianBlur stdDeviation={4} in="SourceGraphic" />
                </filter>
              </defs>
              <g
                transform="translate(8 4.944)"
                fill="url(#apslinemob3)"
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
              >
                <path
                  opacity={0.509341969}
                  filter="url(#bpslinemob3)"
                  d="M5.82645043e-13 5.05627441L3.89431763 15.4422913 105.110474 5.05627441z"
                />
                <path d="M0.440917969 0L4.3352356 10.3860168 105.551392 0z" />
              </g>
            </svg>
          </h3>
          <ul className={style.linksContainer}>
            <li>
              <Link to="/google-workspace">Google Workspace</Link>
            </li>
            <li>
              <Link to="/office365">Microsoft Office</Link>
            </li>
          </ul>

          <h3>
            Resources
            <svg className={style.headerunder} viewBox="0 0 118 29">
              <defs>
                <linearGradient
                  x1="12.4534884%"
                  y1="50.3409839%"
                  x2="87.8953488%"
                  y2="49.6712586%"
                  id="apslinemob4"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-11.4%"
                  y="-115.5%"
                  width="122.8%"
                  height="331.1%"
                  filterUnits="objectBoundingBox"
                  id="bpslinemob4"
                >
                  <feGaussianBlur stdDeviation={4} in="SourceGraphic" />
                </filter>
              </defs>
              <g
                transform="translate(8 4.944)"
                fill="url(#apslinemob4)"
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
              >
                <path
                  opacity={0.509341969}
                  filter="url(#bpslinemob4)"
                  d="M5.82645043e-13 5.05627441L3.89431763 15.4422913 105.110474 5.05627441z"
                />
                <path d="M0.440917969 0L4.3352356 10.3860168 105.551392 0z" />
              </g>
            </svg>
          </h3>
          <ul className={style.linksContainer}>
            <li>
              <Link to="/partners">Partners</Link>
            </li>
            <li>
              <Link to="/tools">Tools</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className={style.menuwrap}>
        <div className={style.toparrow}>
          <svg width="124px" height="54px" viewBox="0 0 124 54">
            <defs>
              <linearGradient
                x1="12.4534884%"
                y1="52.2463131%"
                x2="87.8953488%"
                y2="47.8343369%"
                id="antmob"
              >
                <stop stopColor="#1D8DBA" offset="0%" />
                <stop stopColor="#03ECAE" offset="100%" />
              </linearGradient>
              <filter
                x="-13.4%"
                y="-52.7%"
                width="126.7%"
                height="205.3%"
                filterUnits="objectBoundingBox"
                id="bntmob"
              >
                <feGaussianBlur stdDeviation={5} in="SourceGraphic" />
              </filter>
              <linearGradient
                x1="12.4534884%"
                y1="54.0999225%"
                x2="87.8953488%"
                y2="46.0472782%"
                id="cntmob"
              >
                <stop stopColor="#1D8DBA" offset="0%" />
                <stop stopColor="#03ECAE" offset="100%" />
              </linearGradient>
            </defs>
            <g
              transform="rotate(-179 59.696 22.981)"
              stroke="none"
              strokeWidth={1}
              fill="none"
              fillRule="evenodd"
            >
              <path
                fill="url(#antmob)"
                opacity={0.487932478}
                filter="url(#bntmob)"
                transform="rotate(-6 57.364 20.28)"
                d="M1.20268209 24.558514L58.3875111 23.5603491 113.524923 6.03707338 59.0878906 34.5234375z"
              />
              <path
                fill="url(#cntmob)"
                d="M1.20268209 24.558514L58.4573207 27.5597399 113.524923 6.03707338 59.2624147 44.5219145z"
              />
            </g>
          </svg>
        </div>
        <div className={style.navbox} onMouseLeave={mouseLeave}>
          {'proservice' === activeMenu ? <ProServiceMenu parentw="800" parenth="500" /> : ''}
          {'managedservice' === activeMenu ? (
            <ManagedServiceMenu parentw="800" parenth="400" />
          ) : (
            ''
          )}
          {'collaboration' === activeMenu ? <Collaboration /> : ''}
        </div>
        <svg className={style.navlaser} width="322px" height="61px" viewBox="0 0 322 61">
          <defs>
            <linearGradient
              x1="12.4534884%"
              y1="50.5960699%"
              x2="87.8953488%"
              y2="49.425331%"
              id="anavmob"
            >
              <stop stopColor="#1D8DBA" offset="0%" />
              <stop stopColor="#03ECAE" offset="100%" />
            </linearGradient>
            <filter
              x="-3.9%"
              y="-29.5%"
              width="107.7%"
              height="159.1%"
              filterUnits="objectBoundingBox"
              id="bnavmob"
            >
              <feGaussianBlur stdDeviation={4} in="SourceGraphic" />
            </filter>
          </defs>
          <g
            transform="translate(5.984 -18.316)"
            fill="url(#anavmob)"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
          >
            <path
              opacity={0.22}
              filter="url(#bnavmob)"
              transform="rotate(-7 157.485 39.313)"
              d="M2 19L34.6060181 53.9386597 312.969971 59.6259155 42.1849365 47.0255737z"
            />
            <path d="M2 19L34.6060181 53.9386597 312.969971 59.6259155 42.1849365 47.0255737z" />
          </g>
        </svg>
      </div>
      <div className={style.headerActions}>
        <Link aria-label="Observian Cloud Professionals" to="/">
          <Logo
            colorLogo
            showText
            className={style.logoContainer}
            classNames={{ logo: style.logo, text: style.text }}
          />
        </Link>
        <div data-testid="nav-menu-icon" role="presentation" className={style.navMenu}>
          <div className={style.menuWrapper}>
            <ul data-testid="nav-menu" className={clsx(style.menu, isActive && style.showMenu)}>
              <li className={style.navLinks} ref={proServ} onMouseEnter={proServeEnter}>
                <Link className={style.navLink} to="/aws">
                  Pro Services
                </Link>
              </li>
              <li className={style.navLinks} ref={managedServ} onMouseEnter={managedServEnter}>
                <Link className={style.navLink} to="/managed-service">
                  Managed Services
                </Link>
              </li>
              <li className={style.navLinks} ref={collab} onMouseEnter={collabEnter}>
                <Link className={style.navLink} to="/google-workspace">
                  Collaboration
                </Link>
              </li>
              <li className={style.navLinks} onMouseEnter={mouseEnterClear}>
                <Link className={style.navLink} to="/partners">
                  Partners
                </Link>
              </li>
              <li className={style.navLinks} onMouseEnter={mouseEnterClear}>
                <Link className={style.navLink} to="/tools">
                  Tools
                </Link>
              </li>
              <li className={style.navLinks} onMouseEnter={mouseEnterClear}>
                <Link className={style.navLink} to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  ) : (
    <header
      data-testid="nav-header"
      className={clsx(style.header, isActive && style.headerColor)}
      ref={pRef}
    >
      <div className={style.headerActions}>
        <Link aria-label="Observian Cloud Professionals" to="/">
          <Logo
            colorLogo
            showText
            className={style.logoContainer}
            classNames={{ logo: style.logo, text: style.text }}
          />
        </Link>
        <div data-testid="nav-menu-icon" role="presentation" className={style.navMenu}>
          <div className={style.menuWrapper}>
            <ul data-testid="nav-menu" className={clsx(style.menu, isActive && style.showMenu)}>
              <Button
                label="Contact Observian"
                onClick={() => setShowModal(true)}
                className={style.landingButton}
              />
            </ul>
          </div>
        </div>
      </div>
      {showModal ? (
        <ContactModal
          showClose
          shouldCloseOnOverlayClick
          onClose={() => setShowModal(false)}
          onDismiss={() => setShowModal(false)}
          isOpen={showModal}
          closeButtonPosition="right"
          ariaHideApp={false}
          success={isSuccessful}
        >
          <ContactForm
            showLogo
            headerTitle="Contact Us"
            buttonLabel="Send"
            isLandingPage
            ctaIntentSuffix="modal-ad-landing-contact-top-cta"
            inquiryPlaceholder="I'd like to see how Observian can help my business."
            isSuccessfulCallback={(v) => {
              setIsSuccessful(v)
              if (!v) {
                setShowModal(false)
              }
            }}
          />
        </ContactModal>
      ) : null}
    </header>
  )
}

export default Header
